import { render, staticRenderFns } from "./TokenPowerSetting.vue?vue&type=template&id=dd3ddca4&scoped=true"
import script from "./TokenPowerSetting.vue?vue&type=script&lang=js"
export * from "./TokenPowerSetting.vue?vue&type=script&lang=js"
import style0 from "./TokenPowerSetting.vue?vue&type=style&index=0&id=dd3ddca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ddca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
